import { render } from "./TeamComponent.vue?vue&type=template&id=3ca4cc58&scoped=true"
import script from "./TeamComponent.vue?vue&type=script&lang=js"
export * from "./TeamComponent.vue?vue&type=script&lang=js"

import "./TeamComponent.vue?vue&type=style&index=0&id=3ca4cc58&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca4cc58"]])

export default __exports__